import { Component, OnInit, OnDestroy, Inject, ViewChild } from "@angular/core";
import { HttpClient } from '@angular/common/http';
import { DefaultValuesService } from '../../../services/defaultvalues.service';
import { Utils } from '../../../utils/utils';
import { SaveService } from '../../../services/save.service';
import { Subscription } from "rxjs";
import { CustomerDocumentListComponent } from "./customerdocument-list.component";
import { CustomerDocumentFilterComponent } from "./customerdocument-filter.component";

@Component({
    selector: "customerdocument",
    templateUrl: './customerdocument.component.html',
    standalone: false
})

export class CustomerDocumentComponent implements OnInit, OnDestroy {

    list: CustomerDocument[] = [];

    title = "Customer Documents";
    showLocalFilter = false;

    subscriptionStage: any;
    subscriptionTenant: any;
    subscriptions: Subscription[] = [];

    @ViewChild(CustomerDocumentListComponent, { static: true }) listComponent!: CustomerDocumentListComponent;
    @ViewChild(CustomerDocumentFilterComponent, { static: true }) filterComponent!: CustomerDocumentFilterComponent;

    constructor(
        private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string
        , public defaults: DefaultValuesService
        , private saveService: SaveService
    ) { }

    ngOnInit(): void {
        this.subscriptionStage = this.defaults.stageMessageChanges$.subscribe(() => {
            this.getFilteredCustomerDocumentsByTenant()
            this.listComponent.clonedItemsList = {}
        });
        this.subscriptionTenant = this.defaults.tenantMessageChanges$.subscribe(() => {
            this.getFilteredCustomerDocumentsByTenant()
            this.listComponent.clonedItemsList = {}
        });
        if (this.defaults.tenant)
            this.getFilteredCustomerDocumentsByTenant()
    }

    ngOnDestroy() {
        this.saveService.removeListener(this);
        this.subscriptionStage.unsubscribe();
        this.subscriptionTenant.unsubscribe();
        this.subscriptions.forEach(x => x.unsubscribe())
    }

    getFilteredCustomerDocumentsByTenant() {
        const filter: CustomerDocumentFilter = {
            'DocumentIds': this.filterComponent.documentIds,
            'CustomerIds': this.filterComponent.customerIds,
            'ContractNumbers': this.filterComponent.contractNumbers,
            'UnitIds': this.filterComponent.unitIds,
            'DocumentTypes': this.filterComponent.documentTypes
        }
        Utils.httpGetCustomerDocuments(
            this.http
            , this.baseUrl
            , this.defaults.stage
            , filter
            , this
            , function (tthis: CustomerDocumentComponent, list: CustomerDocument[]) {
                tthis.list = list;
                tthis.listComponent.clonedItemsList = {}
                tthis.listComponent.expandedElements = new Set();
                tthis.saveService.showSaveButton(false)
                if (filter.DocumentIds.length < 1 && filter.CustomerIds.length < 1 && filter.ContractNumbers.length < 1 && filter.UnitIds.length < 1 && filter.DocumentTypes.length < 1)
                    tthis.showLocalFilter = false;
                else
                    tthis.showLocalFilter = true;
            }
        )
    }

    onReload() {
        this.getFilteredCustomerDocumentsByTenant();
        this.listComponent.clonedItemsList = {};
        this.saveService.showSaveButton(false);
    }

    downloadCustomerDocumentFiltered() {
        const filter: CustomerDocumentFilter = {
            'DocumentIds': this.filterComponent.documentIds,
            'CustomerIds': this.filterComponent.customerIds,
            'ContractNumbers': this.filterComponent.contractNumbers,
            'UnitIds': this.filterComponent.unitIds,
            'DocumentTypes': this.filterComponent.documentTypes
        }
        Utils.httpDownloadCustomerDocuments(
            this.http
            , this.baseUrl
            , this.defaults.stage
            , this.defaults.tenant
            , filter
            , this
            , null
        );
    }
}